var map = {
	"./views/case.vue": [
		"e980",
		"chunk-0081a484",
		"chunk-20aaeb06"
	],
	"./views/case1.vue": [
		"5a9a",
		"chunk-0081a484",
		"chunk-35ae10f8"
	],
	"./views/home.vue": [
		"6511"
	],
	"./views/news.vue": [
		"1474",
		"chunk-81622e38"
	],
	"./views/product.vue": [
		"146f",
		"chunk-f0272f4a"
	],
	"./views/service.vue": [
		"182e",
		"chunk-0c6eea55"
	],
	"./views/service1.vue": [
		"cac7",
		"chunk-604365ec"
	],
	"./views/xh.vue": [
		"0406",
		"chunk-305a1437"
	],
	"./views/xh1.vue": [
		"dae8",
		"chunk-e2830216"
	],
	"./views/xhhc.vue": [
		"e449",
		"chunk-d551210c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "627e";
module.exports = webpackAsyncContext;